import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const MoreHorizIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g
        xmlns="http://www.w3.org/2000/svg"
        id="heroicons-outline:dots-vertical"
      >
        <path
          id="Vector"
          d="M4.16536 10.0007L4.1737 10.0007M9.9987 10.0007L10.007 10.0007M15.832 10.0007L15.8404 10.0007M4.9987 10.0007C4.9987 10.2217 4.9109 10.4336 4.75462 10.5899C4.59834 10.7462 4.38638 10.834 4.16536 10.834C3.94435 10.834 3.73239 10.7462 3.57611 10.5899C3.41983 10.4336 3.33203 10.2217 3.33203 10.0007C3.33203 9.77964 3.41983 9.56768 3.57611 9.4114C3.73239 9.25512 3.94435 9.16732 4.16536 9.16732C4.38638 9.16732 4.59834 9.25512 4.75462 9.4114C4.9109 9.56768 4.9987 9.77964 4.9987 10.0007ZM10.832 10.0007C10.832 10.2217 10.7442 10.4336 10.588 10.5899C10.4317 10.7462 10.2197 10.834 9.9987 10.834C9.77768 10.834 9.56572 10.7462 9.40944 10.5899C9.25316 10.4336 9.16536 10.2217 9.16536 10.0007C9.16536 9.77964 9.25316 9.56768 9.40944 9.4114C9.56572 9.25512 9.77768 9.16732 9.9987 9.16732C10.2197 9.16732 10.4317 9.25512 10.588 9.4114C10.7442 9.56768 10.832 9.77964 10.832 10.0007ZM16.6654 10.0007C16.6654 10.2217 16.5776 10.4336 16.4213 10.5899C16.265 10.7462 16.053 10.834 15.832 10.834C15.611 10.834 15.3991 10.7462 15.2428 10.5899C15.0865 10.4336 14.9987 10.2217 14.9987 10.0007C14.9987 9.77964 15.0865 9.56768 15.2428 9.4114C15.3991 9.25511 15.611 9.16732 15.832 9.16732C16.053 9.16732 16.265 9.25511 16.4213 9.4114C16.5776 9.56768 16.6654 9.77964 16.6654 10.0007Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </BaseIcon>
  );
};

MoreHorizIcon.displayName = 'MoreHorizIcon';
